module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "button-bar"
  }, [_c('router-link', {
    staticClass: "btn btn-success",
    attrs: {
      "to": "/clients/new"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Client")])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('div', {
    staticClass: "well"
  }, [_c('h3', [_vm._v("Filter")]), _vm._v(" "), _c('h4', [_vm._v("Current Phase")]), _vm._v(" "), (_vm.clientPhaseFilteringButtons.length > 0) ? _c('button-group', {
    attrs: {
      "vertical": "true",
      "buttons": _vm.clientPhaseFilteringButtons,
      "full-width": true
    },
    model: {
      value: (_vm.clientsFiltering.activePhase),
      callback: function($$v) {
        _vm.clientsFiltering.activePhase = $$v
      },
      expression: "clientsFiltering.activePhase"
    }
  }) : _c('spinner', {
    attrs: {
      "inline": true
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 col-sm-8"
  }, [_c('table-list', {
    attrs: {
      "records": _vm.filteredClients,
      "fields": _vm.fields,
      "has-edit": "/clients/{?}/locations",
      "row-clickable": "true"
    },
    on: {
      "modelChange": _vm.clientsChanged
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5886efb3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Clients.vue
// module id = 291
// module chunks = 0